import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getQcMessageAppConfigurationState = createSelector(
  getDragonflyState,
  (state) => state?.qcMessageAppConfiguration,
);

export const getName = createSelector(getQcMessageAppConfigurationState, (state) => state?.name);

export const getNotificationEmail = createSelector(
  getQcMessageAppConfigurationState,
  (state) => state?.notificationEmail,
);

export const getStatus = createSelector(getQcMessageAppConfigurationState, (state) => state?.isActive);

export const getUsername = createSelector(getQcMessageAppConfigurationState, (state) => state?.username);

export const getPassword = createSelector(getQcMessageAppConfigurationState, (state) => state?.password);

export const getLookBackDays = createSelector(getQcMessageAppConfigurationState, (state) => state?.lookBackDays);

export const getShowCancelBtn = createSelector(getQcMessageAppConfigurationState, (state) => state?.showCancelBtn);

export const getShowUpdateBtn = createSelector(getQcMessageAppConfigurationState, (state) => state?.showUpdateBtn);

export const getDisableNameValue = createSelector(getQcMessageAppConfigurationState, (state) => state?.disableName);

export const getShowNotificationEmailErrorMessage = createSelector(
  getQcMessageAppConfigurationState,
  (state) => state?.notificationEmailShowErrorMessage,
);

export const getShowLookBackDaysValidationErrorMessage = createSelector(
  getQcMessageAppConfigurationState,
  (state) => state?.lookBackDaysShowErrorMessage,
);

export const getQcEndpointConfHelpTextStatus = createSelector(
  getQcMessageAppConfigurationState,
  (state) => state?.endpointConfigurationHelpTextStatus,
);

export const getCredentialsConfigurationHelpTextStatus = createSelector(
  getQcMessageAppConfigurationState,
  (state) => state?.credentialsConfigurationHelpTextStatus,
);

export const getCampaignReportingHelpTextStatus = createSelector(
  getQcMessageAppConfigurationState,
  (state) => state?.campaignReportingHelpTextStatus,
);

export const getQcMessageAppDataIsSubmitted = createSelector(
  getQcMessageAppConfigurationState,
  (state) => state?.isSubmittedData,
);

export const getShowNameErrorMsg = createSelector(getName, getQcMessageAppDataIsSubmitted, (name, dataIsSubmitted) =>
  !name && dataIsSubmitted ? true : false,
);

export const getShowNotificationEmailErrorMsg = createSelector(
  getNotificationEmail,
  getQcMessageAppDataIsSubmitted,
  (email, dataIsSubmitted) => (!email && dataIsSubmitted ? true : false),
);

export const getShowUsernameErrorMsg = createSelector(
  getUsername,
  getQcMessageAppDataIsSubmitted,
  (username, dataIsSubmitted) => (!username && dataIsSubmitted ? true : false),
);

export const getShowPasswordErrorMsg = createSelector(
  getPassword,
  getQcMessageAppDataIsSubmitted,
  getShowUpdateBtn,
  (password, dataIsSubmitted, isEditMode) => (!password && dataIsSubmitted && !isEditMode ? true : false),
);

export const getShowLookBackDaysErrorMsg = createSelector(
  getLookBackDays,
  getQcMessageAppDataIsSubmitted,
  (lookBackDays, dataIsSubmitted) => (lookBackDays === null && dataIsSubmitted ? true : false),
);

export const getQcMessageAppDataAreValid = createSelector(
  getName,
  getUsername,
  getPassword,
  getLookBackDays,
  getShowLookBackDaysValidationErrorMessage,
  getShowUpdateBtn,
  (name, username, pass, lookBackDays, showLookBackDaysValidationErrorMessage, isEditMode) =>
    name && username && (pass || isEditMode) && lookBackDays !== null && !showLookBackDaysValidationErrorMessage
      ? true
      : false,
);
